import { useLicenseStore } from "@/core/store/LicenseStore";
import { useUserStore } from "@/core/store/UserDataStore";
import { ROUTE_ROOT } from "constants/routes";
import { useLogoutQuery } from "core/api/logout/logout";
import { store } from "core/store";
import { setAuth, useAuthStore } from "core/store/reducers/AuthSlice";
import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout: FC = () => {
  const navigate = useNavigate();
  const { reset } = useLicenseStore();
  const { resetUserData } = useUserStore();
  const { logout } = useAuthStore();

  const { isLoading: isLogoutLoading } = useLogoutQuery();

  function logoutHandler() {
    setTimeout(() => {
      logout();
      reset();
      resetUserData();
      navigate(ROUTE_ROOT);
    }, 50);
  }
  useEffect(() => {
    !isLogoutLoading && logoutHandler();
  }, [isLogoutLoading]);

  return <></>;
};
export default Logout;
